import currencyFormatter from "currency-formatter";

const defaultCurrency = process.env.VUE_APP_DEFAULT_CURRENCY;

/**
 * Formats number by its currency
 * putting currency symbol after numeric value
 *
 * @param {number} num
 * @param {string} code
 * @param {number} precision
 * @returns {string}
 */
export const numberWithCurrency = (num, code, precision = 0) => {
  const parameters = {
    code: defaultCurrency,
    format: "%v %s",
    precision,
  };

  if (code === "RUR") {
    parameters.code = "RUB";
  } else if (code === "BONUS") {
    parameters.symbol = "ҍ";
  } else if (code === "empty") {
    if (num === "") {
      return ""
    }
    parameters.format = "%v";
  } else if (code === "symbol") {
    parameters.code = defaultCurrency;
    parameters.format = "%s";
  } else {
    parameters.code = code || defaultCurrency;
  }

  return currencyFormatter.format(num, parameters).replace(/(?!^)-(\s+)?/, ",");
};
